/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class e{constructor(e){this.layer=null,this.memory=0,this.displayedNumberOfFeatures=0,this.maximumNumberOfFeatures=null,this.totalNumberOfFeatures=null,this.layer=e.layer;const t=e.performanceInfo;this.memory=t.usedMemory,this.displayedNumberOfFeatures=t.displayedFeatures,this.maximumNumberOfFeatures=t.maximumFeatures,this.totalNumberOfFeatures=t.totalFeatures}}export{e as default};
